import React, { useState, useEffect } from "react";
import "../../components/PetCrateQuantity/PetCrateQuantity.css";
import axios from "axios";

const PetCrateQuantity = ({
  crateSelObj,
  selectedCrate_ID,
  setCrateSelObj,
  tokenStorage,
  setOpenProfile,
}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [error, setError] = useState("");

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    // console.log("Stored Token:", storedToken);

    if (storedToken && selectedCrate_ID) {
      axios
        .get(
          `${baseAPI}adminget/GetPetCrateQuantity?Crate_ID=${selectedCrate_ID}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {       
          const data = response.data.data[0];
          setCrateSelObj({
            ...data,
            Is_Active: data.Is_Active === 1,
          });
        })
        .catch((error) => {
          console.error("Error fetching crate quantity details:", error);
        });
    }
  }, [selectedCrate_ID, baseAPI, setCrateSelObj]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "total_Inventory") {
      if (value === "" || /^[0-9\b]+$/.test(value)) {
        setCrateSelObj((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      const updatedValue = name === "Is_Active" ? value === "true" : value;
      setCrateSelObj((prevData) => ({
        ...prevData,
        [name]: updatedValue,
      }));
    }
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name === "total_Inventory") {
  //     if (value === "" || /^[0-9\b]+$/.test(value)) {
  //       setCrateSelObj({
  //         ...FormData,
  //         [name]: value,
  //       });
  //     }
  //   } else {
  //     const updatedValue = name === "Is_Active" ? value === "true" : value;
  //     setCrateSelObj((prevData) => ({
  //       ...prevData,
  //       [name]: updatedValue,
  //     }));
  //   }
  // };

  const getRegionID = (regionName) => {
    switch (regionName) {
      case "North":
        return 1;
      case "East":
        return 2;
      case "West":
        return 3;
      case "South":
        return 4;
      default:
        return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const payload = {
        Tseed: crateSelObj.Tseed,
        RegionID: getRegionID(crateSelObj.Region_Name),
        InventoryName: "Crate",
        Region_Name: crateSelObj.Region_Name,
        Crate_Type_Id: crateSelObj.Crate_Type_Id,
        total_Inventory: crateSelObj.total_Inventory,
        Is_Active: crateSelObj.Is_Active ? 1 : 0,
        Created_By: "Admin",
      };

      const response = await axios.post(
        `${baseAPI}adminpost/AddRegionInventory`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );

      // Reload the list
      tokenStorage(); // Trigger re-fetch to update the list

      // Optionally clear form data or close the profile editing UI
      setCrateSelObj({
        Crate_Type_Id: "",
        Region_Name: "",
        total_Inventory: "",
        Is_Active: "",
      });
      setOpenProfile(false);
    } catch (error) {
      console.error("Error posting data:", error);
      setError("Failed to submit data. Please try again.");
    }
  };

  return (
    <div className="container-fluid">
      <br />
      <div className="petCrateQuantityDetail">
        <form className="petCrateQuantity-form" onSubmit={handleSubmit}>
          {error && <p className="error">{error}</p>}
          <table style={{ width: "100%" }}>
            <tbody>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
              <tr className="tableHeading">
                <td>Product Name</td>
                <td>Region Name</td>
                <td>Quantity</td>
                <td>Status</td>
              </tr>
              <tr>
                <td>
                  <input
                    type="text"
                    name="Crate_Type_Name"
                    value={crateSelObj.Crate_Type_Name || ""}
                    placeholder="Enter Quantity"
                    onChange={handleChange}
                    disabled
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                    }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="Region_Name"
                    value={crateSelObj.Region_Name || ""}
                    placeholder="Enter Please"
                    disabled
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                    }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="total_Inventory"
                    value={crateSelObj.total_Inventory || ""}
                    placeholder="Enter Quantity"
                    onChange={handleChange}
                    required
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                    }}
                  />
                </td>
                <td>
                  <select
                    name="Is_Active"
                    value={crateSelObj.Is_Active ? "true" : "false"}
                    onChange={handleChange}
                    required
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                    }}
                  >
                    <option value={"true"}>Active</option>
                    <option value={"false"}>Inactive</option>
                  </select>
                </td>
              </tr>
              <tr className="space">
                <td colSpan={3}></td>
              </tr>
            </tbody>
          </table>
          <br />

          <div className="reset-addPetCrateQuantity-button">
            <button
              type="submit"
              style={{
                marginRight: "10px",
                backgroundColor: "#5B489D",
                color: "white",
              }}
            >
              Apply
            </button>
            <button
              type="button"
              style={{ backgroundColor: "#F15843", color: "white" }}
              onClick={() => {
                setCrateSelObj((prevData) => ({
                  ...prevData,
                  total_Inventory: "",
                  Is_Active: "true", 
                }));
              }}
            >
              Reset
            </button>
          </div>
        </form>
      </div>
      <br />
    </div>
  );
};

export default PetCrateQuantity;
